var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// a-drop-wrapper.ts
import { isSafari } from "@adornis/base/client/frontend-helpers/window-size";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BehaviorSubject } from "rxjs";
import tippy, { sticky } from "tippy.js";
import tippycss from "tippy.js/dist/tippy.css";
var ADropTrigger = class extends ChemistryLitElement {
  constructor() {
    super();
    this["manual-close"] = false;
    this.isOpen$ = new BehaviorSubject(false);
    this.options = {};
    this.style.display = "block";
    ADropTrigger.attachTippyStyle();
  }
  static attachTippyStyle() {
    if (this.tippyStyleAttached)
      return;
    const tippyCss = document.createElement("style");
    tippyCss.innerHTML = tippycss + ".tippy-box[data-theme~='custom'] { background-color: transparent; color: inherit; } .tippy-box[data-theme~='custom'] .tippy-content { padding: 0; } [data-tippy-root] * { outline: 0 }";
    document.head.appendChild(tippyCss);
    const animationCssElement = document.createElement("link");
    animationCssElement.rel = "stylesheet";
    animationCssElement.href = "/proxy/tippy/shift-away.css";
    document.head.appendChild(animationCssElement);
    const outlineHack = document.createElement("style");
    outlineHack.innerHTML = "[data-tippy-root] * { outline: 0 }";
    document.head.appendChild(outlineHack);
    this.tippyStyleAttached = true;
  }
  set content(content) {
    if (this._content === content)
      return;
    this._content = content;
    if (this._content.receiveTrigger)
      this._content.receiveTrigger(this);
    if (this._content.eventTarget)
      this._content.eventTarget = this;
    this.reinit();
  }
  get content() {
    return this._content;
  }
  _defaultOptions() {
    return {
      content: this.content,
      placement: "bottom-start",
      interactive: true,
      trigger: "manual",
      triggerTarget: this,
      appendTo: window.document.body,
      animation: isSafari() ? void 0 : "shift-away",
      // no animation for safari b/c shadows are kinda broken there
      maxWidth: "none",
      hideOnClick: false,
      theme: "custom",
      arrow: false,
      duration: [200, 300],
      delay: [0, 0],
      sticky: true,
      // shouldnt use because not very speedy, but it fixes the first-time-wrong-position issue
      plugins: [sticky],
      // dito
      // if somewhere else, then close
      onClickOutside: (instance, event) => {
        if (this["manual-close"])
          return;
        const isMe = event.composedPath().includes(this) || event.composedPath().includes(this.content);
        const isOtherDropdownContent = event.composedPath().find((path) => {
          return path instanceof HTMLElement ? path.classList.toString().includes("tippy-box") : false;
        });
        if (!isMe && !isOtherDropdownContent)
          this.close();
      },
      zIndex: 1003
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.reinit();
  }
  reinit() {
    this.tippy?.destroy();
    this.tippy = tippy(
      // @ts-ignore tippy always takes the wrong overload
      this,
      {
        ...this._defaultOptions(),
        ...this.options,
        onShow: () => {
          this.dispatchEvent(new CustomEvent("open"));
          this.isOpen$.next(true);
        },
        onHide: () => {
          this.dispatchEvent(new CustomEvent("close"));
          this.isOpen$.next(false);
        }
      }
    );
  }
  isOpen() {
    return this.tippy?.state.isVisible || false;
  }
  async open() {
    this.tippy?.show();
  }
  close() {
    return new Promise((resolve) => {
      this.tippy?.hide();
      setTimeout(
        () => requestAnimationFrame(() => resolve()),
        Array.isArray(this.tippy?.props.duration) ? this.tippy?.props.duration[1] ?? 250 : this.tippy?.props.duration
      );
    });
  }
  toggle() {
    if (this.tippy?.state.isVisible)
      this.close();
    else
      this.open();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.tippy?.destroy();
  }
  render() {
    return html`
      <slot></slot>
      <slot name="trigger"></slot>

      <slot
        name="dropdown-content"
        @slotchange=${(e) => {
      const thisSlot = e.currentTarget;
      const contentElement = Array.from(thisSlot.assignedNodes())[0];
      if (!contentElement)
        return;
      this.content = contentElement;
    }}
      ></slot>
    `;
  }
};
ADropTrigger.tippyStyleAttached = false;
__decorateClass([
  property({ type: Boolean })
], ADropTrigger.prototype, "manual-close", 2);
ADropTrigger = __decorateClass([
  customElement("a-dropdown")
], ADropTrigger);
export {
  ADropTrigger
};
